import { Phone } from "lucide-react";
import { BUSINESS } from "../data/business";

/**
 * Sticky bottom-right floating call button — mobile only.
 * Highest-converting CTA for local salon on mobile devices.
 */
export default function MobileCallBar() {
  return (
    <a
      href={`tel:${BUSINESS.phones[1].tel}`}
      data-testid="mobile-call-fab"
      aria-label={`Zadzwoń do BEAUTIX ${BUSINESS.phones[1].number}`}
      className="lg:hidden fixed bottom-6 right-5 z-40 flex items-center gap-2 bg-[var(--beautix-pink)] hover:bg-[var(--beautix-pink-dark)] text-white px-5 py-3.5 rounded-full shadow-[0_12px_30px_-8px_rgba(224,62,132,0.55)] active:scale-95 transition-transform"
    >
      <Phone className="w-4 h-4" strokeWidth={1.75} />
      <span className="text-sm font-medium tracking-wide">
        {BUSINESS.phones[1].number}
      </span>
    </a>
  );
}
